(function ( $ ) {
 
  $.fn.showForm = function( options ) {

  	var settings = $.extend({
      target: 			'',
      classToApply: '',
      overflowEl: 	''
    }, options );
    
    this.click(function(e){
    	e.preventDefault();
    	$( settings.overflowEl ).fadeToggle(function(){
    		$( settings.target ).toggleClass( settings.classToApply );
    	});
    })

    $( settings.overflowEl ).click(function(){
    	$( settings.target ).removeClass( settings.classToApply );
    	$(this).fadeOut();
    });

  };

}( jQuery ));